<div class="igntr-theme flex-1 bg-[var(--background-color)]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px]"
  >
    <form
      [formGroup]="editForm"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
    >
      <div class="flex items-end justify-between gap-3 mb-3">
        <app-page-hero [title]="'createDocument'"></app-page-hero>
        <button
          type="submit"
          class="shrink-0 px-3.5 h-9 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
        >
          {{ "save" | transloco }}
        </button>
      </div>

      <div class="rounded-xl border !border-slate-200/70 bg-white">
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "title" | transloco }}
            </span>
          </div>
          <div [appValidateState]="editForm.get('title')">
            <input
              id="title"
              formControlName="title"
              type="text"
              class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
              placeholder="{{ 'title' | transloco }}"
              autocomplete="off"
              (keydown.enter)="$event.preventDefault()"
            />
          </div>
        </div>

        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "documentType" | transloco }}
            </span>
          </div>
          <div [appValidateState]="editForm.get('documentTypeId')">
            <app-datalist-select
              [options]="DocumentTypeOptions"
              [multiple]="false"
              [activeValue]="editForm?.value.documentTypeId"
              (activeValueChange)="updateValue('documentTypeId', $event)"
            ></app-datalist-select>
          </div>
        </div>

        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">
              {{ "document" | transloco }}
            </span>
          </div>

          <input
            #fileInput
            type="file"
            class="hidden"
            (change)="onFileSelected($any($event.target).files)"
          />

          <div [appValidateState]="editForm.get('document')">
            @if (currentFileName) {
              <div
                class="flex items-center gap-3 px-3 py-2 rounded-lg bg-white border !border-slate-200/70 hover:!border-slate-300 transition-colors"
              >
                <span
                  class="w-10 h-10 rounded-md bg-slate-50 shrink-0 inline-flex items-center justify-center !text-slate-400"
                >
                  <igntr-icon name="file" [size]="20"></igntr-icon>
                </span>

                <div class="min-w-0 flex-1">
                  <div class="text-[13px] font-medium !text-slate-800 truncate">
                    {{ currentFileName }}
                  </div>
                </div>

                <button
                  type="button"
                  (click)="fileInput.click()"
                  [title]="'replace' | transloco"
                  class="shrink-0 p-1.5 rounded-md !text-slate-400 hover:!text-slate-700 hover:bg-slate-100 inline-flex transition-colors"
                >
                  <igntr-icon name="refresh" [size]="15"></igntr-icon>
                </button>
              </div>
            } @else {
              <div
                class="rounded-lg border !border-dashed px-4 py-2.5 text-center transition-colors"
                [ngClass]="
                  isDragOver
                    ? '!border-[var(--primary-color)] bg-[color-mix(in_srgb,var(--primary-color)_6%,white)]'
                    : '!border-slate-300 bg-white'
                "
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
              >
                <div
                  class="flex flex-wrap items-center justify-center gap-2 text-[12px] font-medium !text-slate-500"
                >
                  <span>{{ "dropFilesOr" | transloco }}</span>
                  <button
                    type="button"
                    (click)="fileInput.click()"
                    class="text-[12px] font-medium bg-white border !border-slate-200 px-3 h-8 rounded-lg inline-flex items-center justify-center !text-slate-700 hover:!bg-slate-50 transition-colors"
                  >
                    {{ "browse" | transloco }}
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
